import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import fileDownload from "js-file-download";
import { baseUrl } from "../utils/Constants";

export const UserMaintanenceSlice = createSlice({
  name: "UserMaintanenceList",
  initialState: {
    UserMaintanenceData: [],
  },
  reducers: {
    setError: (state) => {
      state.error = true;
    },
    setUserMaintanenceData: (state, { payload }) => {
      state.error = false;
      state.UserMaintanenceData = payload;
    },
    updateUserMaintanenceData: (state, { payload }) => {
      state.error = false;

      const existingObject = state.UserMaintanenceData[0];

      console.log(existingObject, " existingone ");
      const newestUser = {
        sno: "",
        Enterprise_ID: "",
        Supervisor: "",
        Admin: "no",
        "isActive": "yes",
      };

      const newUserObject = {
        ...newestUser,
        Enterprise_ID: payload.username,
        Supervisor: payload.supname,
        Admin: "",
        isActive:"yes",
      };

      console.log(newUserObject, " newUserObject ");
      console.log("state.userMaintenanceData", state.UserMaintanenceData[0]);
      state.UserMaintanenceData.push(newUserObject);
      state.UserMaintanenceData.map((item, i) => {
        item.sno = i + 1;
      });
    },
  },
});

export const { setError, setUserMaintanenceData, updateUserMaintanenceData } =
  UserMaintanenceSlice.actions;

export default UserMaintanenceSlice.reducer;

export function getUserMaintanenceData() {
  return (dispatch) => {
    axios
      .get(`${baseUrl}/fetchusermaintanencedata`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        let newArray;
        if (res.data != undefined && res.data != null) {
          newArray = res.data.map((item, index) => {
            const newItem = {
              sno: index + 1,
              ...item,
            };
            return newItem;
          });
        }
        console.log(res.data, "fetch user maintenance");
        dispatch(setUserMaintanenceData(newArray));
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}

export function addUser(username, supname) {
  return (dispatch) => {
    axios
      .post(
        `${baseUrl}/adduser`,
        { username, supname },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        dispatch(updateUserMaintanenceData({ username, supname }));
        console.log("res from role based on ent id", res.data);
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}

export function submitUserRoles(roles) {
  console.log(roles)
  return (dispatch) => {
    axios
      .post(
        `${baseUrl}/adduserroles`,
        { roles },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        console.log("res from role based on ent id", res.data);
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}

export function updateSupervisor(Supervisor, Enterprise_ID) {
  return (dispatch) => {
    axios
      .put(
        `${baseUrl}/updateSupervisor`,
        { Supervisor, Enterprise_ID },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        console.log("updated supervisor details");
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}

export function deleteEnterpriseID(Enterprise_ID_Del) {
  console.log("Enterprise id in redux", Enterprise_ID_Del);
  return (dispatch) => {
    axios
      .delete(`${baseUrl}/deleteEnterpriseID/${Enterprise_ID_Del}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("deleted EnterpriseID");
      })
      .catch((err) => {
        dispatch(setError(err));
        console.log("error in deleting Enterprise ID is", err);
      });
  };
}

export function downloadUserRoles() {
  return (dispatch) => {
    axios.get(`${baseUrl}/downloadExcel`, {
      responseType: "blob",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    })
      .then((res) => {
        fileDownload(res.data, `User Roles.xlsx`);
      })
      .catch((err) => {
        dispatch(setError(err))
        console.error("download failed");
      });
  };
}

export function uploadUserRoles(formData) {
  return (dispatch) => {
    axios
      .post(`${baseUrl}/uploaduserrole`, formData, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        dispatch(setError(err))
        console.error("upload fail");
      });
  };
}

export const selectAdminIds = (state) => state.userRoles?.UserMaintanenceData ?.filter((user) =>
  String(user.Admin).toLowerCase() === "yes" ) ?.map((user) => user.Enterprise_ID?.toLowerCase()
);